import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotRank from "./components/HotRank";
import TopicSquare from "./components/TopicSquare";
import Viewpoints from "./components/Viewpoints";
import TeaHouse from "./components/TeaHouse";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <HotRank />
        <TopicSquare />
        <Viewpoints />
        <TeaHouse />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}